import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import { ThumbnailView } from '../_common';
import { MediaActions } from '../../_redux';
import { MediaGalleryConstants } from '../../constants';
import ThumbnailItem from './ThumbnailItem';

const { MEDIA_FROM } = MediaGalleryConstants;

const FILE_ACCEPT = 'image/jpeg, image/png, image/gif, .mp4, .avi, .mpg';

const mapStateToProps = state => {
  const id = state.business.get('businessDetails').get('business');
  return {
    business_id: id && id.get && id.get('id'),
    medias: state.media.get(`${MEDIA_FROM.mine}`).toList().toJS().reverse(),
    selection: state.media.get('selection'),
    progress: state.media.get('progress'),
    uploading: state.media.get('uploading'),
    // medias: _.orderBy(state.media.get('medias').toList().toJS()
    //   .filter((m) => m.from === MEDIA_FROM.mine), (m) => m.id, 'asc')
  };
};

const mapDispatchToProps = {
  // ADD_MEDIA: MediaActions.ADD_MEDIA,
  // CREATE_MEDIA: MediaActions.CREATE_MEDIA,
  REMOVE_MEDIA: MediaActions.REMOVE_MEDIA,
  DELETE_MEDIA: MediaActions.DELETE_MEDIA,
  // CHANGE_MEDIA: MediaActions.CHANGE_MEDIA,
  SET_MEDIA_SELECTION: MediaActions.SET_MEDIA_SELECTION,
  UPLOAD_MEDIA: MediaActions.UPLOAD_MEDIA,
};

class MyMedias extends React.Component {
  static propTypes = {
    uploading: PropTypes.bool,
    business_id: PropTypes.number,
    imageField: PropTypes.string,
    selection: PropTypes.object,
    progress: PropTypes.object,
    medias: PropTypes.array,
    checkIsSelectionAllowed: PropTypes.func,
    onCrop: PropTypes.func.isRequired,
    REMOVE_MEDIA: PropTypes.func.isRequired,
    DELETE_MEDIA: PropTypes.func.isRequired,
    SET_MEDIA_SELECTION: PropTypes.func.isRequired,
    UPLOAD_MEDIA: PropTypes.func.isRequired,
  };

  onDrop = accepted => {
    accepted.forEach(file => {
      const clientId = new Date().getTime();
      const type = file.type === 'image/gif' ? 'GIF' : ((file.type.indexOf('video/') > -1 && 'VIDEO') || 'IMAGE');

      this.uploads[clientId] = file;
      this.createMedia({
        file_name: file.name, url: file.preview, id: clientId, type,
      });
    });
  }

  uploads = {}

  refDropzone = node => {
    this.dropzone = node;
  }

  createMedia = media => {
    const { file_name, id } = media;

    const {
      business_id, UPLOAD_MEDIA, imageField,
    } = this.props;
    UPLOAD_MEDIA({
      body: { business_id, file_name }, media, from: MEDIA_FROM.mine, file: this.uploads[id],
    }, imageField)
      .then(res => {
        this.selectMedia(this.props.medias.find(m => m.id === res.media.id));
      });
    // this.selectMedia(this.props.medias.find((m) => m.id === id))

    /*
    return Promise.resolve(ADD_MEDIA(media, MEDIA_FROM.mine))
      .then(() => {
        Promise.resolve(CREATE_MEDIA({ business_id, file_name }, media.id, MEDIA_FROM.mine))
          .then(res => {
            this.updateUploadProgress(media.id, 0);
            uploadFile({
              url: res.media.presigned_upload_url,
              file: this.uploads[id],
              progressCallback: evt => {
                this.updateUploadProgress(res.media.id, (100 * evt.loaded) / evt.total);
              },
              doneCallback: () => {
                Promise.resolve(CHANGE_MEDIA(Object.assign(
                  { ...this.props.medias.find(m => m.id === res.media.id) },
                  { url: res.media.twokey_url, status: null }
                ), MEDIA_FROM.mine))
                  .then(() => {
                    this.selectMedia(this.props.medias.find(m => m.id === res.media.id));
                  });
              },
              errorCallback: evt => {
                console.error(
                  formatMessage({ id: 'media.upload_error', defaultMessage: '!Uploading via presigned url error' }),
                  evt
                );
                this.removeUpload(media);
              },
            });
          })
          .catch(err => {
            console.error(err);
          });
      })
      .catch(err => {
        console.error(err);
      });
      */
  };

  retryUpload = media => {
    this.createMedia(media);
  };

  removeUpload = media => {
    if (media.isTemporary) {
      this.props.REMOVE_MEDIA(media.id, MEDIA_FROM.mine);
    } else {
      this.props.DELETE_MEDIA(media.id, MEDIA_FROM.mine);
    }
  };

  openFileDialog = () => {
    if (!this.props.uploading) {
      this.dropzone.open();
    }
  };

  selectMedia = media => {
    this.props.SET_MEDIA_SELECTION({ ...this.props.selection, media, on: MEDIA_FROM.mine });
  };

  cropImage = (image, e) => {
    e.stopPropagation();

    if (this.props.onCrop) {
      this.props.onCrop(image);
    }
  };

  render() {
    const {
      medias, progress, selection: { media } = {}, checkIsSelectionAllowed, uploading,
    } = this.props;
    return (
      <div className="gallery-container">
        <Dropzone
          disableClick
          ref={this.refDropzone}
          style={{ position: 'relative', height: '100%' }}
          accept={FILE_ACCEPT}
          onDrop={this.onDrop}
          multiple={false}
          disabled={uploading}
        >
          <ThumbnailView
            newItemEnabled={!uploading}
            data={medias}
            selections={media}
            onNewItem={this.openFileDialog}
            // itemRenderer={mediaItemRenderer}
            itemRenderer={ThumbnailItem}
            checkIsSelectionAllowed={checkIsSelectionAllowed}
            itemProps={{
              uploadProgress: progress,
              onCrop: this.cropImage,
              onRetry: this.retryUpload,
              onRemove: this.removeUpload,
            }}
            onChange={this.selectMedia}
          />
        </Dropzone>
      </div>
    );
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MyMedias));
